import { Content } from '../../types';

export const pattayaContent: Content = {
  title: 'פטאיה - העיר שהפכה ממוקד חיי לילה לעיר נופש לכל המשפחה',
  imageUrl: '/images/thailand/pattaya/pattaya-wide.jpeg',
  introduction:
    'פטאיה (Pattaya) שוכנת לאורך חופי מפרץ תאילנד, במרחק של כשעתיים נסיעה מבנגקוק. בעבר, היתה ידועה כ"עיר החטאים" של תאילנד, אך כיום מדובר ביעד נופש תוסס, מגוון ונגיש, הפונה לכל סוגי המטיילים – זוגות, משפחות, צעירים ומטיילים בגפם. השילוב בין חופים יפים, אטרקציות מגוונות, קניות, מופעים, מסעדות וחיי לילה – הביא אותה לבחירה מועדפת על מטיילים מכל העולם. פטאיה אף מציעה גישה נוחה לאיים סמוכים כמו קו לארן (Koh Larn) ואתרי טבע ותרבות בדרום מזרח תאילנד.',
  sections: [
    {
      title: 'מזג אוויר בפטאיה',
      type: 'sub-headers',
      description:
        'פטאיה נהנית מאקלים טרופי חם לאורך כל השנה, שלושת העונות הבולטות הן:',
      content: [
        {
          subtitle: 'העונה היבשה (נובמבר – פברואר)',
          text: 'מזג אוויר נעים, מעט גשמים, תקופה מושלמת לביקור.',
        },
        {
          subtitle: 'העונה החמה (מרץ – מאי)',
          text: 'טמפרטורות גבוהות (עד 35°), מתאימה לחופשת בטן גב ואטרקציות מים.',
        },
        {
          subtitle: 'העונה הגשומה (יוני – אוקטובר)',
          text: 'גשמים בעיקר בשעות אחר הצהריים, אך העיר נשארת פעילה ונעימה למטיילים.',
        },
      ],
    },
    {
      title: 'אזורים מומלצים ללינה בפטאיה',
      type: 'sub-headers',
      description:
        'פטאיה מציעה מגוון אזורי לינה המתאימים לסגנונות שונים של מטיילים:',
      content: [
        {
          subtitle: 'Pattaya Beach (מרכז העיר והחוף המרכזי)',
          text: 'האזור המתוייר ביותר בעיר, סמוך ל –Walking  Street,  למסעדות, לקניונים ולחוף המרכזי. מתאים למחפשים קרבה לכל הפעילויות והאקשן - צעירים, זוגות, חובבי חיי לילה ועוד.<br /> <strong>מלונות פופולריים:</strong> Hilton Pattaya, The Stay Hotel, Avani Pattaya.',
        },
        {
          subtitle: 'חוף Jomtien',
          text: 'חוף ארוך ושקט יותר מדרום למרכז העיר. מתאים למשפחות ולנופשים המעדיפים מרחב ונחת - משפחות, זוגות, גולשים ועוד. מציע גישה נוחה לאטרקציות כמו שוק הלילה, פארקי מים ועוד.<br /> <strong>מלונות פופולריים:</strong> D Varee Jomtien, Grand Jomtien Palace, Zing Resort & Spa.',
        },
        {
          subtitle: 'חוף Naklua & Wongamat Beach',
          text: 'צפון פטאיה, אזור רגוע עם בתי מלון יוקרתיים, מסעדות איכות ואווירה משפחתית. מושלם למעדיפים ניתוק מההמולה אך עדיין מעוניינים בקרבה למרכז - זוגות, משפחות, נופשים המחפשים רוגע ועוד.<br /> <strong>מלונות פופולריים:</strong> Centara Grand Mirage, Pullman Pattaya Hotel G, Cape Dara Resort.',
        },
        {
          subtitle: 'גבעת Pratumnak',
          text: "גבעה שקטה בין מרכז פטאיה לג'ומטיין, עם נוף יפה לים, קרבה למקדש Big Buddha, חופים שקטים ומלונות קטנים ואיכותיים, מתאים בעיקר לזוגות, משפחות ולמטיילים המחפשים שלווה.<br /> <strong>מלונות פופולריים:</strong> Royal Cliff Hotels Group, The Monttra Pattaya.",
        },
        {
          subtitle: 'האי קו לארן (Koh Larn)',
          text: 'אפשרות לינה ייחודית באי ציורי, כ - 30 דקות במעבורת מפטאיה. חוויית אי רגועה עם חופים בתוליים ומהממים. מתאים בעיקר לנופשים המעדיפים טבע ושלווה.<br /> <strong>מלונות פופולריים:</strong> Suntosa Resort, Baan Navy Koh Larn, Sealey Resort.',
        },
      ],
    },
    {
      title: 'תחבורה ציבורית והשכרת רכבים בפטאיה',
      type: 'sub-headers',
      description:
        'למרות שפטאיה אינה עיר גדולה במיוחד, התחבורה בתוכה מגוונת וזולה יחסית ומאפשרת התניידות בין מוקדי העניין:',
      content: [
        {
          subtitle: 'מוניות סונגתאו (Songthaew)',
          text: 'טנדר פתוח עם ספסלים, הנוסעים במסלולים קבועים לאורך הרחובות (כמו Second Road ו - Beach Road). המחיר, לרוב, 10 - 20 באט לאדם. פשוט ביותר - עולים ויורדים כשרוצים – אופציה זולה ופופולרית מאוד. ניתן גם לשכור אותם לנסיעות פרטיות.',
        },
        {
          subtitle: 'מוניות',
          text: 'לא חסרות מוניות רשמיות בעיר, אך חלקן לא מפעילות מונה. מומלץ לסגור על מחיר מראש או להשתמש באפליקציות כמו Bolt או Grab. המחירים, כמובן, גבוהים יותר מהסונגתאו.',
        },
        {
          subtitle: 'אופנועים להשכרה',
          text: 'אופציה נוחה וזולה עבור מטיילים בודדים או זוגות, אך יש לזכור כי נהיגה בתאילנד מחייבת רישיון מתאים בתוקף ובכלל זה רשיון נהיגה בינלאומי. הקפידו על חבישת קסדה, רשיון נהיגה תואם בתוקף וביטוח!<br /><strong> עלות השכרה ליום:</strong> כ – 200 עד 300 באט ליום.',
        },
        {
          subtitle: 'רכב שכור',
          text: 'מתאים למשפחות או מטיילים הרוצים לטייל גם מחוץ לעיר. קל ואף מומלץ לשכור רכבים בתאילנד, אך יש לקחת בחשבון את חוקי התנועה והנהיגה בצד שמאל. <br/><strong> עלות השכרה ליום:</strong> כ – 800 עד 1,500 באט ליום (תלוי בסוג הרכב).',
        },
      ],
    },
    {
      title: 'דרכי הגעה לפטאיה',
      type: 'sub-headers',
      description:
        'פטאיה נגישה במיוחד למטיילים המגיעים מבנגקוק או משדות תעופה נוספים:',
      content: [
        {
          subtitle: 'מוניות מבנגקוק',
          text: 'הדרך הנוחה והמהירה ביותר, כשעתיים נסיעה. ניתן להזמין מונית מראש ו/או באמצעות האפליקציות Bolt ו-Grab. <br/><strong> עלות: </strong>כ-1,200 עד 1,800 באט (תלוי בנקודת המוצא).',
        },
        {
          subtitle: 'מיניוואן/וואן משותף',
          text: 'יוצאים בתדירות גבוהה מתחנות Ekkamai או Mochit שבבנגקוק. נוחים, זמינים וזולים. <br/><strong> עלות: </strong>כ–150 עד 250 באט לאדם.',
        },
        {
          subtitle: 'רכבת מבנגקוק',
          text: 'קו רכבת ישיר מתחנת Hua Lamphong לפטאיה. חוויה שונה, אך איטית יותר. משך הנסיעה: כ-2.5 עד 3 שעות. <br/><strong> עלות: </strong>זולה מאוד – בין 30 ל-100 באט.',
        },
        {
          subtitle: 'שדה התעופה U-Tapao',
          text: 'שוכן כ-45 דקות דרומית לפטאיה. מקבל טיסות פנים וטיסות בינלאומיות מיעדים ספציפיים. מתאים במיוחד למגיעים מדרום תאילנד או ממדינות שכנות.',
        },
      ],
    },
    {
      title: 'חופים מרכזיים בפטאיה',
      type: 'sub-headers',
      description:
        'פטאיה מציעה מגוון של חופים לכל סוגי המטיילים, מחופים עירוניים סואנים ועד חופים שקטים באיים סמוכים:',
      content: [
        {
          subtitle: 'Pattaya Beach',
          text: 'החוף המרכזי של העיר, סמוך ל-Walking Street ולקניון Central Festival. אורכו כ-3 ק"מ מציע ספורט ימי, סירות מצנח, מסעדות, ברים ושירותי חוף. החוף אינו מתאים לרחצה, אך נמצא בלב ההתרחשויות.',
        },
        {
          subtitle: 'Jomtien Beach',
          text: 'חוף נעים ורחב בדרום העיר. אהוב על משפחות, נופשים מקומיים וחובבי גלישת רוח. לאורכו, שדרה של מסעדות ומלונות מעולים. מתאים מאוד לרחצה ולבילוי יומי נינוח.',
        },
        {
          subtitle: 'Dongtan Beach',
          text: "חוף שקט בין פטאיה לג'ומטיין, עם אווירה רגועה וידידותית לקהילה הגאה. החוף מציע גישה נוחה, הרבה צל וספסלים לאורך טיילת מטופחת.",
        },
        {
          subtitle: 'Wongamat Beach / North Pattaya',
          text: 'חוף יוקרתי ורגוע בצפון העיר, סמוך למלונות ברמה גבוהה. המים צלולים יותר והחוף נקי ומטופח. מומלץ למחפשים שלווה בלי להתרחק מהעיר.',
        },
        {
          subtitle: 'Koh Larn',
          text: 'אי טרופי במרחק של כחצי שעה במעבורת מהמרינה. מציע חופים בתוליים, חול לבן ומים כחולים ואפשרויות לפעילויות ימיות כמו שנורלינג, אופנועי ים ובננה בוט. חופים בולטים באי: Tawaen Beach, Samae Beach, Nual Beach.',
        },
      ],
    },
    {
      title: 'אטרקציות מרכזיות בפטאיה',
      type: 'sub-headers',
      description:
        'פטאיה מציעה מגוון רחב של אטרקציות לכל המשפחה, המשלבות בילוי, הנאה וחוויות:',
      content: [
        {
          subtitle: 'פארק המים רמיאנה (Ramayana Water Park)',
          text: 'פארק מים גדול מאוד, המשתרע על פני שטח עצום ומציע יותר מ-20 מגלשות, בריכות גלים, נהרות מלאכותיים, אזורים לקטנטנים ועוד. מתאים ליום שלם של בילוי למשפחות, זוגות וקבוצות.',
        },
        {
          subtitle: 'פארק המים קולומביה (Columbia Pictures Aquaverse)',
          text: 'פארק מים חדשני עם נושאים מעולמות הסרטים של Columbia Pictures, כמו Ghostbusters, Hotel Transylvania ועוד. האטרקציות כוללות מתקנים רטובים ויבשים, מופעים ומפגש עם דמויות אהובות מהמסך.',
        },
        {
          subtitle: 'הגנים הבוטניים Nong Nooch',
          text: 'גן בוטני עצום ויפיפה המשלב גנים מעוצבים, מופעים תרבותיים תאילנדיים, הדגמות אומנויות לחימה, מופעי פילים ופינות חי. חוויה עשירה בצבעים ותרבות.',
        },
        {
          subtitle: 'הדולפינריום של פטאיה',
          text: 'מתקן מודרני ומתקדם עם מופעי דולפינים מרהיבים וידידותיים למשפחות. ניתן גם לשחות לצד הדולפינים (בתשלום נוסף). חוויה מרגשת לילדים ולמבוגרים כאחד.',
        },
        {
          subtitle: 'חוות צאן פטאיה',
          text: 'חוות חיות מותאמת למשפחות עם ילדים – כוללת כבשים, ארנבים, תוכים וחיות נוספות, מתקני משחקים ודוכני מזון. המקום מעוצב באווירה כפרית פסטורלית.',
        },
        {
          subtitle: 'Frost Magical Ice of Siam',
          text: 'פארק קרח ייחודי המציג פסלים מרהיבים מעולם הפנטזיה והמיתולוגיה התאילנדית, העשויים מקרח, בתוך אולם בטמפרטורה של כ-10- מעלות. חוויה מרעננת ביום חם.',
        },
      ],
    },
    {
      title: 'מוזיאונים ואתרי תרבות בפטאיה',
      type: 'sub-headers',
      description:
        'לצד חיי הלילה והבילויים, פטאיה מציעה גם מגוון אתרי תרבות ומוזיאונים מעניינים:',
      content: [
        {
          subtitle: 'מקדש האמת (Sanctuary of Truth)',
          text: 'מקדש עץ מרהיב בגובה של 105 מטר, הבנוי מגילופי עץ מקומיים בעבודת יד. משלב תפיסות תרבות, דתיות ופילוסופיות מהתרבות התאילנדית והאסייתית, חוויה ייחודית ומרגשת.',
        },
        {
          subtitle: 'Wat Phra Yai (Big Buddha Hill)',
          text: 'מקדש בודהיסטי, מהחשובים שבפטאיה, הממוקם על גבעה גבוהה ובה פסל בודהה זהוב ענק, בגובה של 18 מטר. מהגבעה נשקף נוף פנורמי מרהיב של העיר והים. מקום של שקט, נוף והשראה.',
        },
        {
          subtitle: 'מיני סיאם (Mini Siam)',
          text: "פארק מיניאטורות עם מודלים מוקפדים של אתרים מפורסמים בתאילנד ובעולם כולו – מהטאג' מאהל ועד מגדל אייפל. חווית למידה ובילוי מהנה לכל גיל.",
        },
        {
          subtitle: "ריפלי'ס תאמינו או לא!",
          text: 'מוזיאון אטרקציות מוזרות, מופלאות ולעיתים מטרידות – עם פריטים מרחבי העולם שלא תאמינו שקיימים. בנוסף, יש במקום גם בית רוחות, קולנוע 12D ועוד.',
        },
        {
          subtitle: 'Art in Paradise',
          text: 'מוזיאון אמנות תלת-ממד אינטראקטיבי. המבקרים הופכים לחלק מהיצירות עצמן, מה שיוצר כל תמונה לצילום מיוחד וכיפי. מקום מהנה במיוחד למשפחות וזוגות.',
        },
        {
          subtitle: 'מוזיאון הדובים (Teddy Bear Museum)',
          text: 'מוזיאון דובים צבעוני עם יותר מ-1,000 דובים בתצוגות יצירתיות. מותאם במיוחד לילדים קטנים אך גם למבוגרים חובבי דובים.',
        },
      ],
    },
    {
      title: 'חוויות קולינריות בפטאיה',
      type: 'sub-headers',
      description:
        'המטבח התאילנדי פוגש בפטאיה מטבחים מרחבי העולם – ומציע טעמים עשירים ברחובות, בשווקים ובמסעדות:',
      content: [
        {
          subtitle: 'אוכל רחוב',
          text: 'פטאיה מציעה אוכל רחוב כמעט בכל פינה – משיפודי עוף צלוי, דרך פאד תאי מעולה, תירס בחמאה ועד מנגו סטיקי רייס (מנגו עם אורז דביק). שוק הלילה Thepprasit והשוק הצף הם נקודות שיא.',
        },
        {
          subtitle: 'סדנאות בישול תאילנדי',
          text: 'חווית לימוד טעימה במיוחד – מכינים יחד מנות תאילנדיות קלאסיות כמו גרין קארי, סום טאם ופאד תאי. ישנן סדנאות מותאמות לילדים, זוגות וטבעונים.',
        },
        {
          subtitle: 'שוק הדגים בנאקלואה',
          text: 'לצד שוק טרי (בשעות הבוקר), גדול ומיוחד של דגים ופירות ים, ניתן למצוא גם מסעדות המבשלות בהתאם למה שתבחרו בעצמכם. חוויה מקומית ומקורית מאוד לחובבי דגים ופירות ים.',
        },
        {
          subtitle: 'ארוחות מול הים',
          text: 'מסעדות רבות מציעות ארוחות רומנטיות מול השקיעה, במיוחד לאורך החופים של Wongamat, Naklua ו-Jomtien.',
        },
      ],
    },
    {
      title: 'מסעדות מומלצות בפטאיה',
      type: 'sub-headers',
      description: 'פטאיה מציעה מגוון עצום של מסעדות מכל המטבחים והסגנונות:',
      content: [
        {
          subtitle: 'The Sky Gallery Pattaya',
          text: 'מסעדה מודרנית עם נוף מרהיב לים, המציעה תפריט מערבי ותאילנדי, אווירה רגועה ואוכל איכותי. מקום מושלם לשקיעה.',
        },
        {
          subtitle: 'מסעדת Cabbages & Condoms',
          text: 'מסעדה בעלת קונספט חברתי (מנות רמות לחינוך מיני) לצד אוכל תאילנדי משובח. גן ירוק ואווירה נעימה – חוויה קולינרית עם ערך מוסף.',
        },
        {
          subtitle: 'La Baguette French Bakery',
          text: 'מאפיה צרפתית יוקרתית עם מאפים, קפה וקינוחים מצוינים. מושלם לארוחת בוקר או עצירה מתוקה.',
        },
        {
          subtitle: 'Indian by Nature',
          text: 'מהמסעדות ההודיות המעולות שבעיר, עם מנות אותנטיות, תיבול מדוייק, אווירה נעימה ושירות מקצועי.',
        },
        {
          subtitle: 'Surf & Turf Beach Club & Restaurant',
          text: 'בנוסף לאוכל הטעים, מציעה גם מיטות שיזוף ומוזיקה נינוחה לאורך היום.',
        },
      ],
    },
    {
      title: 'חיי לילה בפטאיה',
      type: 'sub-headers',
      description:
        'פטאיה מפורסמת בזכות חיי הלילה הסוערים שלה – ממופעים ועד ברים על הגג, מרחובות מלאי אקשן ועד מועדונים יוקרתיים:',
      content: [
        {
          subtitle: 'Walking Street',
          text: 'רחוב חיי הלילה המרכזי בעיר. מציע ברים, מועדונים, מופעים, מוזיקה חיה, מסעדות ומופעי קברט. המקום פעיל עד השעות הקטנות של הלילה – צבעוני, רועש ומלא באקשן.',
        },
        {
          subtitle: 'רחובות הבילוי Soi 6, Soi 7, Soi 8',
          text: 'רחובות מלאי ברים תוססים ואווירה חשמלית. Soi Buakhao וכל הרחובות הקטנים סביבו הם מוקד נוסף של בילויים.',
        },
        {
          subtitle: "Maggie Choo's Pattaya",
          text: 'בר בנוסח אסייתי-מודרני עם הופעות חיות, תפריט קוקטיילים מוקפד ואווירה מסתורית. מתאים לזוגות או קבוצות המחפשים/ות ערב באווירה שונה.',
        },
        {
          subtitle: 'Sky Bar at Horizon – Hilton Hotel',
          text: 'בר גג אלגנטי עם נוף פנורמי מדהים על כל המפרץ. תפריט קוקטיילים איכותי, אוכל מוקפד ואווירה מעולה – לבילוי רגוע ורומנטי.',
        },
        {
          subtitle: 'מועדוני לילה מרכזיים',
          text: 'The Pier, Lucifer, 808 Club - שלושה מועדונים גדולים ברחוב המרכזי – כל אחד מהם מציע מוזיקה, מסיבות ותקליטנים מכל העולם. קהל צעיר ואווירה תוססת עד לקראת הבוקר.',
        },
        {
          subtitle: "Tiffany's & Alcazar Cabaret Shows",
          text: 'מופעי דראג מהידועים והמשובחים שבתאילנד – הפקות מרשימות עם תלבושות, ריקודים, תפאורה ותחכום. מופעים לכל המשפחה, אך בעיקר למבוגרים.',
        },
      ],
    },
    {
      title: 'קניות ושווקים בפטאיה',
      type: 'sub-headers',
      description:
        'העיר מציעה חוויית קניות מגוונת, משווקים מקומיים ועד קניונים יוקרתיים:',
      content: [
        {
          subtitle: 'Terminal 21 Pattaya',
          text: 'קניון מודרני המעוצב בסגנון טרמינל טיסות עם חנויות רבות של מותגים בינלאומיים. ברחבת הכניסה מתקיימים, בתדירות גבוהה, שווקי יום ולילה מתחלפים ובהם דוכני אוכל, ביגוד, מזכרות ועוד.',
        },
        {
          subtitle: 'Central Festival Pattaya',
          text: 'קניון גדול על קו החוף, עם מגוון חנויות, מסעדות ובידור. בקומה התחתונה, קיים סופרמרקט של רשת Tops וכן, בתדירות גבוהה, מתקיימים במקום שווקים ודוכני מכירה מתחלפים של רשתות ומוצרים שונים.',
        },
        {
          subtitle: 'Central Marina Pattaya',
          text: 'סמוך ל-Terminal 21, עם חנות של רשת Big C ועוד מספר חנויות אאוטלט של מותגי ספורט בינלאומיים. ברחבת הכניסה מתקיים כל ערב שוק אוכל ודוכנים, לא גדול במיוחד אך עם מוזיקה חיה ואווירה נהדרת.',
        },
        {
          subtitle: 'Outlet Mall Pattaya',
          text: 'מרכז קניות משתלם לאוהבי מותגים במחירים נמוכים.',
        },
        {
          subtitle: 'Thepprasit Night Market',
          text: 'שוק הלילה הפופולרי הפועל בכל ימות שבוע, מציע אוכל רחוב, בגדים ומזכרות. מומלץ מאוד!',
        },
        {
          subtitle: 'Pattaya Floating Market',
          text: 'שוק צף בסגנון תאילנדי אותנטי, עם סירות מכירה ודוכנים מסורתיים.',
        },
      ],
    },
    {
      title: 'טיולי יום מפטאיה',
      type: 'sub-headers',
      description:
        'פטאיה מהווה נקודת מוצא נוחה לטיולים קצרים – לאיים, כפרים, טבע ומקדשים:',
      content: [
        {
          subtitle: 'Koh Larn (האי האלמוגים)',
          text: 'האי הפופולרי ביותר באזור פטאיה – נמצא כ-30 דקות הפלגה מהחוף. חופים לבנים, מי טורקיז, ספורט ימי, טיולי טרקטורונים ודוכני אוכל. מומלץ לבילוי של יום שלם ואף ללינת לילה ו/או מספר לילות.',
        },
        {
          subtitle: 'Silverlake Vineyard, Khao Chi Chan',
          text: 'כרם יין רחב ידיים המציע סיורים, טעימות ואווירה אירופאית. בסמוך אליו ממוקם "הר הבודהה" עם גילוף זהב ענק על צלע ההר. מקום פסטורלי ומרשים כאחד.',
        },
        {
          subtitle: 'Cartoon Network Amazone in Pattaya',
          text: 'לשעבר, כפר דייגים שליו עם מסעדות דגים משובחות, פחות מתוייר. לאחר מכן, שימש המקום כפארק מים גדול וכיום מתפתח מחדש כמרכז תיירות אקולוגית.',
        },
        {
          subtitle: 'Chanthaburi',
          text: 'טיול של יום ארוך (או לילה) למחוז ירוק ופחות מתוייר – גנים, מפלים, שוק אבני חן וקתדרלה צרפתית מהמאה ה-19. מתאים עבור מטיילים המחפשים גיוון תרבותי.',
        },
      ],
    },
    {
      title: 'ספא ומרכזי בריאות בפטאיה',
      type: 'sub-headers',
      description:
        'לא רק בילויים – פטאיה מציעה גם רגיעה ושלווה עם טיפולים מסורתיים, יוגה ומרכזי ספא יוקרתיים:',
      content: [
        {
          subtitle: "Let's Relax Spa",
          text: "רשת ספא תאילנדית מצויינת בעלת מספר סניפים בעיר. מסאז'ים תאילנדים, שוודיים, עיסויים ארומטיים, טיפולי פנים ועוד. רמה גבוהה מאוד!",
        },
        {
          subtitle: 'Oasis Spa Pattaya',
          text: 'ספא יוקרתי ומעוצב בנוסח תאילנדי מסורתי. חבילות זוגיות מפנקות, טיפולים טבעיים, אווירה פסטורלית ושירות מוקפד.',
        },
        {
          subtitle: 'Health Land Spa & Massage',
          text: "מרכז מסאז'ים פופולרי המציע חוויה מקצועית במחיר נוח. מתאים גם לקבוצות ולמשפחות. יש להזמין מראש.",
        },
        {
          subtitle: 'Yoga Pattaya',
          text: 'בפטאיה, מרכזי יוגה רבים בהם מתקיימים שיעורי יוגה, מדיטציה ופילאטיס למתחילים ולמתקדמים, כולל חוגים באוויר הפתוח – דרך מעולה לשחרר את הנפש בתוך כל ההמולה.',
        },
      ],
    },
    {
      title: 'חוויות למשפחות עם ילדים',
      type: 'sub-headers',
      description:
        'פטאיה מתאימה מאוד עבור משפחות – עם מגוון של פעילויות מהנות ובטוחות:',
      content: [
        {
          subtitle: 'Underwater World Pattaya',
          text: 'אקווריום מרשים עם מנהרות תת-ימיות, חוויית האכלת כרישים, מדוזות, דגי ענק ועוד. חוויה חינוכית ומרתקת לילדים.',
        },
        {
          subtitle: 'Elephant Jungle Sanctuary Pattaya',
          text: 'חווה טיפולית לפילים – ניתן להאכיל, לרחוץ ולהכיר מקרוב את בעלי החיים הנפלאים הללו, בלא לפגוע בהם. מתאים מאוד למשפחות האוהבות טבע ובעלי חיים.',
        },
        {
          subtitle: 'HarborLand Pattaya',
          text: 'מרכז פעילויות ענק לילדים – מתקנים מתנפחים, מגלשות, אזורים לקטנטנים, מסלולי טיפוס ועוד. מקום מקורה ומעוצב – מושלם ליום גשום או חם.',
        },
        {
          subtitle: 'Monster Aquarium Pattaya',
          text: 'גן חיות קטן אך מרתק – עם דגים, לטאות, עכבישים, עופות ותצוגות אינטראקטיביות שילדים אוהבים.',
        },
      ],
    },
    {
      title: 'חוויות רומנטיות בפטאיה',
      type: 'sub-headers',
      description:
        'למרות המוניטין הרועש – פטאיה מציעה גם פינות קסומות עבור זוגות:',
      content: [
        {
          subtitle: 'שקיעה ב-Viewpoint Pattaya',
          text: 'נקודת תצפית מהממת על כל קו החוף. מומלץ להגיע לקראת שקיעה, בקבוק יין קטן יהווה תוספת מעולה ולהתפעל מהנוף הצבעוני.',
        },
        {
          subtitle: 'שייט פרטי לאי סמוך',
          text: 'סיורים פרטיים על יאכטות או סירות מהירות – עם עצירות באיים מבודדים, ארוחות על הסיפון, שנורקלינג וצילומים רומנטיים.',
        },
        {
          subtitle: 'ארוחת ערב למול השקיעה',
          text: 'מסעדות כמו The Glass House, The Sky Gallery ו-Rimpa Lapin, מציעות שולחנות רומנטיים ממש על קו החוף – חוויה בלתי נשכחת.',
        },
        {
          subtitle: 'ספא זוגי מפנק',
          text: 'דגש על ספא יוקרתי עם טיפול ארומטי, אמבטיה פרחים, כיבוד קל ושירות מעולה – הדרך האידיאלית לסיים יום טיול.',
        },
      ],
    },
    {
      title: 'אתרי צלילה, שנורקלינג וספורט ימי',
      type: 'sub-headers',
      description:
        'הים סביב פטאיה אולי פחות מפורסם ופחות מומלץ מאיי הדרום, אך יש בו לא מעט חוויות ספורט ימי המתאימות גם למתחילים:',
      content: [
        {
          subtitle: 'שנורקלינג באי קו לאן (Koh Larn)',
          text: 'האי המפורסם ביותר ליד פטאיה מציע מים צלולים יחסית, שוניות אלמוגים רדודות ודגים טרופיים צבעוניים – אידאלי לחובבי שנורקלינג קליל.',
        },
        {
          subtitle: 'צלילה מודרכת למתחילים',
          text: 'בפטאיה תמצאו מועדוני צלילה המציעים קורסי צלילה וחוויות צלילה יומיות, הכוללים/ות ציוד מלא, מדריך אישי וצלילה באתרי צלילה בטוחים ליד קו סאק (Koh Sak) או קו פאי (Koh Pai) הסמוכים לקו לארן.',
        },
        {
          subtitle: 'מצנחי רחיפה ואטרקציות ימיות',
          text: 'לאורך חופי פטאיה ובאי קו לאן ניתן למצוא אינספור אטרקציות ימיות: מצנחי רחיפה, אופנועי ים, אבובים, גלשני רוח ועוד – ניתן לתאם פעילויות ישירות בחופים או באמצעות הסוכנויות הרבות ואף בחלק מבתי המלון.',
        },
        {
          subtitle: 'Pattaya Sea Walking',
          text: 'הליכה על קרקעית הים - חוויה ייחודית, בה חובשים קסדת חמצן מיוחדת וצועדים על קרקעית הים בין הדגים. מתאים אף למי שלא יודע לשחות.',
        },
        {
          subtitle: 'Pattaya Yacht Charters',
          text: 'למחפשי חוויה יוקרתית – ניתן לשכור יאכטה פרטית ליום שלם, כולל צוות, אוכל, ציוד שנורקינג ואפילו דייג – לחוויית VIP ימית.',
        },
      ],
    },
    {
      title: 'פסטיבלים ואירועים מיוחדים',
      type: 'sub-headers',
      description:
        'פטאיה מארחת לאורך השנה שלל אירועים מקומיים ובינלאומיים – צבעוניים, מוזיקליים ותרבותיים:',
      content: [
        {
          subtitle: 'Pattaya Music Festival (מרץ – אפריל)',
          text: 'פסטיבל מהגדולים בתאילנד – מוזיקה בבמות פתוחות לאורך החוף, הופעות חיות של אמנים מקומיים ובינלאומיים. חינם לחלוטין ולכל המשפחה.',
        },
        {
          subtitle: 'פסטיבל Songkran – חג המים (אפריל)',
          text: 'הגרסה של פטאיה לחג התאילנדי החשוב והפופולרי ביותר, עם קרבות מים, הופעות, מסיבות חוף ואלפי משתתפים – חגיגה אמיתית של שמחה ואחווה. המופעים המרכזיים נערכים לאורך החוף המרכזי.',
        },
        {
          subtitle: 'Pattaya International Pride Festival (יוני)',
          text: 'מצעד צבעוני ותוסס המהווה את שיא אירועי חודש הקהילה הגאה – עם הופעות, תלבושות ססגוניות ומסרים של סובלנות וחופש. פתוח לכולם ובאווירה חיובית.',
        },
        {
          subtitle:
            'Festival Pattaya Wan Lai Songkran – סונגקראן המאוחר (אפריל)',
          text: 'בפטאיה חוגגים את חג המים אף במהלך מספר ימים מעבר לחגיגות באזורים נוספים ברחבי המדינה – בדרך כלל באמצע אפריל. הזדמנות נוספת להצטרף לטירוף.',
        },
      ],
    },
    {
      title: 'מידע שימושי למטיילים בפטאיה',
      type: 'sub-headers',
      description:
        'טרם הגעתכם לפטאיה, כדאי להכיר מספר פרטים חשובים אשר יעשו את החוויה שלכם נעימה, בטוחה וחלקה:',
      content: [
        {
          subtitle: 'מטבע ושירותים פיננסיים',
          text: "המטבע המקומי הינו הבאט תאילנדי (THB). ניתן להמיר כסף בצ'יינג'ים הרבים הפזורים ברחבי העיר (לרוב, שער טוב יותר מאשר בשדה התעופה). כרטיסי אשראי מתקבלים ברוב המלונות והקניונים, אך בשווקים ובתחבורה מקומית – מזומן הוא המלך.",
        },
        {
          subtitle: 'סים מקומי ותקשורת',
          text: 'קל ונוח לרכוש סים מקומי של חברות כמו AIS, True או DTAC. ניתן לרכוש סים בשדות התעופה, בקניונים או בחנויות רשת 7-Eleven, עם חבילות גלישה משתלמות במיוחד לתיירים.',
        },
        {
          subtitle: 'שפה ותקשורת',
          text: 'אנגלית בסיסית מדוברת במרבית אזורי התיירות, אך כדאי להכיר מילים בתאית בסיסית כמה (כמו סוואדיקה/סוואדיקראפ לשלום, קאפ קון קראפ – תודה). חיוך עושה פלאים!',
        },
        {
          subtitle: 'מזג אוויר ועונות מומלצות',
          text: 'פטאיה נהנית ממזג אוויר חם כל השנה. העונה המומלצת לביקור: נובמבר–מרץ (יבשה וקרירה יחסית). אפריל–אוקטובר: עונה חמה יותר ולעתים גשומה, אך עדיין תיירותית ונעימה.',
        },
        {
          subtitle: 'בריאות ובטיחות',
          text: 'הקפידו על שתייה מבקבוקים סגורים בלבד, מרפאות ובתי מרקחת זמינים בכל אזורי התיירות ומשטרת התיירות זמינה אף היא במספר 1155 (אנגלית).',
        },
        {
          subtitle: 'אמצעי תחבורה בתוך העיר',
          text: 'הסונגתאו (מוניות שירות פתוחות), הינן הדרך הזולה והנוחה ביותר לנוע בעיר. אפליקציות כמו Bolt או Grab שימושיות ומומלצות ביותר עבור הזמנת מונית והשכרת קטנועים/אופנועים אמנם פופולרית מאוד, אך מחייבת זהירות רבה – ומומלץ בחום לעשות זאת אך ורק עם ביטוח מלא ורישיון בינלאומי תקף.',
        },
      ],
    },
    {
      title: 'טיפים חשובים למטיילים בפטאיה',
      type: 'sub-headers',
      description: 'טיפים שיעזרו לכם ליהנות מחופשה מוצלחת בפטאיה:',
      content: [
        {
          subtitle: 'גישה פתוחה',
          text: 'בואו עם ראש פתוח – פטאיה מגוונת ומלאת ניגודים – חיי לילה סוערים לצד חופים שלווים ואטרקציות משפחתיות.',
        },
        {
          subtitle: 'היזהרו מהונאות',
          text: 'הימנעו מהונאות/עקיצות תיירים – היו זהירים במיוחד עם נהגי מוניות/טוקטוקים או הצעות "זולות מדי". ברוב המקרים - מה שנשמע טוב מדי כדי להיות אמיתי, הוא ככל הנראה כזה.',
        },
        {
          subtitle: 'כבוד לתרבות המקומית',
          text: 'כבדו את התרבות המקומית – דגש על ביקורים באתרים דתיים: לבוש צנוע, התנהגות שקטה, לא להפנות רגליים לעבר פסלי בודהה.',
        },
        {
          subtitle: 'הגנה משמש ושתייה',
          text: 'השתמשו בקרם הגנה ושתו הרבה מים קרים – השמש התאילנדית חזקה אף אם לא תמיד זה נראה כך, במיוחד באי קו לארן ובטיולי יום פתוחים.',
        },
        {
          subtitle: 'גילוי הצד האותנטי',
          text: 'נסו אף את הצד המקומי של העיר – לא רק אזורי התיירות. שווקים, מסעדות רחוב מקומיות ומקדשים פחות מוכרים מציעים חוויות אותנטיות ומחירים נמוכים.',
        },
      ],
    },
    {
      title: 'לסיכום – מדוע לבקר בפטאיה?',
      type: 'text',
      content:
        'פטאיה של היום הינה הרבה מעבר לעיר של חיי לילה – היא מהווה יעד תיירותי תוסס ומגוון המציע מגוון אפשרויות נופש ובילוי לכלל המטיילים. בין אם הינכם מעוניינים בחופים טרופיים, מים ואטרקציות לילדים, תרבות תאילנדית מפוארת, שופינג משתלם או בילויים עד השעות הקטנות – פטאיה לא תאכזב אתכם.\n\n<br/>מיקומה הנוח, רק כשעתיים נסיעה מבנגקוק, הופך אותה ליעד מצוין לחופשה קצרה או לעצירה בדרך לאיים הדרומיים. עם תחבורה נוחה, שפע של מלונות, מסעדות ואטרקציות ויחס מעולה עבור המחיר – קל להבין מדוע פטאיה ממשיכה להוות אחד היעדים הפופולריים בתאילנד.<br/>\n\nאם תתכננו נכון – תגלו עיר שיודעת לשלב בין מנוחה, הרפתקאות, בילויים ותרבות. אז קדימה, ארזו בגד ים, כובע, חיוך והרבה סקרנות – פטאיה מחכה לכם',
    },
  ],
};
